
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/period-changes",
      function () {
        return require("private-next-pages/period-changes.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/period-changes"])
      });
    }
  